import { EventEmitter } from 'event-emitter';

import page from 'page-common';

export class DialogWrapper extends EventEmitter {
	create = data => page.modals.create(data);
	show = dialog => page.modals.show(dialog);
	hide = dialog => page.modals.hide(dialog);
}
